import { getTimeLeftLabel } from '@griply/utils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FlagFilled } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { useToday } from 'shared/contexts/today';
import { Timestamp } from 'shared/types/timestamp';

import * as Styled from './time-left.style';

export type TimeLeftProps = {
  date: Timestamp;
  isShort?: boolean;
  isMidShort?: boolean;
  isCompleted?: boolean;
};

export const TimeLeft: React.FC<TimeLeftProps> = ({
  date,
  isShort,
  isMidShort,
  isCompleted,
}) => {
  const today = useToday();
  const { t } = useTranslation();

  const { label, isOverdue, isLastWeek } = getTimeLeftLabel(date, {
    today,
    t,
    short: isShort,
    midShort: isMidShort,
    isCompleted,
  });

  if (isCompleted) {
    return (
      <Styled.Container $isCompleted>
        <Styled.IconContainer>
          <Icon icon={FlagFilled} />
        </Styled.IconContainer>
        <Styled.Label>{label}</Styled.Label>
      </Styled.Container>
    );
  }

  return (
    <Styled.Container $overdue={isOverdue} $lastWeek={isLastWeek}>
      <Styled.IconContainer>
        <Icon icon={FlagFilled} />
      </Styled.IconContainer>

      <Styled.Label>{label}</Styled.Label>
    </Styled.Container>
  );
};
